export default __webpack_public_path__ + "static/media/siakap_menangis.18ae171a.png";